/**
 * Normalizes translations/assignments filter-option responses from getMethod2.
 * Laravel payloads are often wrapped in `data`, may nest again, and keys vary
 * (singular vs plural, or a generic `options` array).
 */
export function extractAssignmentFilterOptions(response, keys = []) {
  if (response == null) return [];
  const keyList = (Array.isArray(keys) ? keys : [keys]).filter(Boolean);

  // getMethod2 resolves [] on some error paths — not a competition list.
  if (Array.isArray(response) && response.length === 0) return [];

  // Sometimes the endpoint returns the list as a bare array.
  if (
    Array.isArray(response) &&
    response.length > 0 &&
    typeof response[0] === "object"
  ) {
    return response;
  }

  const bodies = [];
  const push = (b) => {
    if (b != null && typeof b === "object") bodies.push(b);
  };
  push(response);
  if (response && typeof response === "object" && response.data !== undefined) {
    push(response.data);
    const inner = response.data;
    if (inner && typeof inner === "object" && inner.data !== undefined) {
      push(inner.data);
    }
  }

  for (const body of bodies) {
    if (Array.isArray(body)) return body;
    for (const k of keyList) {
      if (k && Array.isArray(body[k])) return body[k];
    }
    if (Array.isArray(body.options)) return body.options;
    if (Array.isArray(body.items)) return body.items;
    if (Array.isArray(body.results)) return body.results;
  }
  return [];
}

/** Query fragment: `languages[]=1&languages[]=2` for store-filter-options. */
export function buildLanguagesQuery(langIds) {
  return langIds
    .map((id) => `languages[]=${encodeURIComponent(id)}`)
    .join("&");
}

/** Map one API row to `{ id, option }` for ReusableAutocompleteWithID. */
export function toAssignmentSelectOption(item) {
  const id =
    item.id ??
    item.competition_id ??
    item.organization_id ??
    item.country_id ??
    item.language_id ??
    item.grade_id ??
    item.value ??
    item.key;
  const option =
    item.name ||
    item.display_name ||
    item.option ||
    item.label ||
    item.title ||
    item.text ||
    item.competition_name ||
    item.organization_name ||
    item.language_name ||
    (id != null && id !== "" ? String(id) : "");
  return { id, option };
}
